import { z } from "zod"

export const CreateWishlistSchema = z.object({
  name: z.string().min(1).max(35),
})

export function safeParse(values) {
  const errors = {}
  const { error: parseError } = CreateWishlistSchema.safeParse(values)
  for (const { path, message } of parseError?.issues || []) {
    errors[path.join(".")] = { message }
  }
  return errors
}
